import styled from 'styled-components';

import { zIndex } from '@/constants/zIndex';

interface Props {
  displayTime: string;
  targetTime: number;
  missionCompleted: boolean;
  clickable: boolean;
  onClick: () => void;
}

const StickyMissionHeader = ({ displayTime, targetTime, missionCompleted, clickable, onClick }: Props) => (
  <Header missionCompleted={missionCompleted} onClick={clickable ? onClick : undefined}>
    <ProgressWrapper missionCompleted={missionCompleted}>
      <Progress missionCompleted={missionCompleted}>{displayTime}</Progress>
    </ProgressWrapper>
    {missionCompleted ? '미션 완료하고 티켓 받았어요' : `${targetTime}초 읽으면 티켓 받아요`}
  </Header>
);

export default StickyMissionHeader;

const Header = styled.header<{ missionCompleted: boolean }>`
  z-index: 999;
  height: 44px;
  background: ${({ theme, missionCompleted }) => (missionCompleted ? theme.color.primary100 : theme.color.blue100)};
  position: sticky;
  top: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  ${({ theme }) => `
    ${theme.typography.UI14SB};
    color: ${theme.color.gray800};
  `}
`;

const ProgressWrapper = styled.div<{ missionCompleted: boolean }>`
  position: relative;
  width: 50px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  overflow: hidden;

  ${({ theme, missionCompleted }) =>
    missionCompleted
      ? `
    background: ${theme.color.primary200};
    color: ${theme.color.primary700};
  `
      : `
    background: ${theme.color.blue200};
    color: ${theme.color.blue700};      
  `};

  @keyframes rotate {
    100% {
      transform: rotate(1turn);
    }
  }

  ${({ missionCompleted }) =>
    missionCompleted
      ? ''
      : `
  ::before {
    content: '';
    position: absolute;
    width: 50px;
    height: 50px;
    background: conic-gradient(
      transparent,
      rgba(51, 154, 240, 1),
      transparent 30%
    );
    animation: rotate 1s linear infinite;
    overflow: hidden;
  }
  `}
`;

const Progress = styled.div<{ missionCompleted: boolean }>`
  position: relative;
  width: 47px;
  height: 23px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  overflow: hidden;
  z-index: ${zIndex.AppHeader};

  ${({ theme, missionCompleted }) =>
    missionCompleted
      ? `
    background: ${theme.color.primary200};
    color: ${theme.color.primary700};
  `
      : `
    background: ${theme.color.blue200};
    color: ${theme.color.blue700};      
  `};
`;
